import { render, staticRenderFns } from "./DiscountedProductSlider.vue?vue&type=template&id=a01dfcae&scoped=true&"
import script from "./DiscountedProductSlider.vue?vue&type=script&lang=js&"
export * from "./DiscountedProductSlider.vue?vue&type=script&lang=js&"
import style0 from "./DiscountedProductSlider.vue?vue&type=style&index=0&id=a01dfcae&scoped=true&lang=css&"
import style1 from "./DiscountedProductSlider.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a01dfcae",
  null
  
)

export default component.exports